import React, { useCallback, useMemo } from 'react';

// material-ui
import { Grid, Table, TableBody, TableRow, TableCell } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  teamContainer: {
    width: '100%',
    textAlign: 'center',
  },
  teamName: {
    color: 'white',
    fontSize: '16px',
    fontWeight: 600,
    padding: '10px',
  },
  teamPerson: {
    fontSize: '14px',
    padding: '5px 0px',
    borderBottom: '1px groove rgba(0, 0, 0, 0.1)',
    borderRight: '1px groove rgba(0, 0, 0, 0.1)',
    background: 'white',
  },
  teamPlayer: {
    '&:hover': {
      cursor: 'pointer',
      fontWeight: 'bold',
    },
  },
}));

const Person = ({ person, teamName, onClickPerson }: PersonProps) => {
  // style
  const classes = useStyles();

  const onClick = useCallback(() => {
    onClickPerson([teamName, person.number || -1, person.name].filter(Boolean).join(' ')
    );
  }, [onClickPerson, teamName, person.number, person.name]);

  const { playerName, playerNumber } = useMemo(() => {
    const { number, name } = person;
    return {
      playerNumber: number || '',
      playerName: name || '',
    };
  }, [person]);

  return (
    <Grid
      item
      xs={6}
      className={clsx(classes.teamPerson, classes.teamPlayer)}
      key={person.id}
      onClick={onClick}
    >
      {(playerNumber || playerName) && `${playerNumber}. ${playerName}`}
    </Grid>
  );
};

const PersonListView = ({ personList, teamName, onClickPerson }: PersonListViewProps) => {
  return (
    <Grid container>
      {personList.map(person => (
        <Person key={person.id} person={person} teamName={teamName} onClickPerson={onClickPerson} />
      ))}
    </Grid>
  );
};

const TeamView = (teamInfo: TeamViewProps) => {
  // style
  const classes = useStyles();

  const { onClickPerson } = teamInfo;

  const { teamName, teamCoach } = useMemo(() => {
    return {
      teamName: teamInfo.teamName || '데이터가 존재하지 않습니다',
      teamCoach: teamInfo.teamCoach ? `감독 : ${teamInfo.teamCoach}` : '데이터가 존재하지 않습니다',
    };
  }, [teamInfo]);

  return (
    <Grid container className={classes.teamContainer}>
      <Grid item xs={12} className={classes.teamName} style={{ background: teamInfo.teamColor }}>
        {teamName}
      </Grid>
      <Grid item xs={12} className={classes.teamPerson}>
        {teamCoach}
      </Grid>
      <Grid item xs={12}>
        <PersonListView personList={teamInfo.personList} teamName={teamName} onClickPerson={onClickPerson} />
      </Grid>
    </Grid>
  );
};

export default TeamView;
